import { BiometricsResource } from "@repo/core/services/resources/biometrics";
import { apiInstance } from "@repo/core/services/instances/api";
import { BIOMETRICS_FLOW } from "@repo/core/services/entities/Biometrics";

const biometricsResource = new BiometricsResource(apiInstance);

export interface RegisterBiometryStepProps {
  step: BIOMETRICS_FLOW;
  lngProposta: number;
  /** For `SELFIE`, pass the `selfie` object from `GET /unico/process/:id` (serialized as `strRetorno`). */
  response: object;
  /** Required for `BIOMETRICS_FLOW.SELFIE` (Único): upload response `lngDocumento` as string */
  strNumeroDocumento?: string;
}

export const useBiometryRegister = () => {
  const registerBiometryStepLog = async ({
    step,
    lngProposta,
    response,
    strNumeroDocumento
  }: RegisterBiometryStepProps) => {
    try {
      const payload = {
        lngProposta,
        strTipoDeFluxo: step,
        strRetorno: JSON.stringify(response),
        ...(strNumeroDocumento !== undefined &&
        String(strNumeroDocumento).trim() !== ""
          ? { strNumeroDocumento: String(strNumeroDocumento).trim() }
          : {})
      };

      const { data } = await biometricsResource.registerConsultation(payload);

      return data;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    registerBiometryStepLog
  };
};
